import {Component, EventEmitter, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {AuditService} from '../audit.service';
import {DateRangeService} from '../../core/services/date-range.service';
import {LookupModel} from '../../api/models/lookup-model';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import {MatDialog} from '@angular/material/dialog';
import { AuditListFilterDialogComponent } from './audit-list-filter-dialog/audit-list-filter-dialog.component';
import {SelectedFilterValuesModel} from '../../dialogs/grid-filter/selected-filter-values.model';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { AuditGridComponent } from './grid/audit-grid.component';

@Component({
    selector: 'app-users',
    templateUrl: './audit.component.html',
    styleUrls: ['./audit.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        GridFilterComponent,
        AuditGridComponent,
    ],
})
export class AuditComponent extends BaseComponent implements OnInit {

  buttonSubmitPromise: Promise<void>;
  filterChangeEvent = new EventEmitter<any>();
  selectedFilterChange = new EventEmitter<SelectedFilterValuesModel[]>();

  selectedFilter: SelectedFilterValuesModel[] = new Array<SelectedFilterValuesModel>();
  filterOptions: FilterOptionModel[] = [];
  auditTypes: LookupModel[] = [];
  auditCategories: LookupModel[] = [];
  auditUsers: LookupModel[] = [];

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              public dialog: MatDialog,
              public dateRangeService: DateRangeService,
              private router: Router,
              private auditService: AuditService,
  ) {
    super(route, headerService, titleService, authService);
    this.editRoles = [RolesEnum.Audit_Edit, RolesEnum.Audit_Delete];
    this.deleteRoles = [RolesEnum.Audit_Delete];

    this.dateRangeService.onDateRangeChange(this.dateRangeService.dateRanges[7]);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.initLookupOptions();
  }

  initLookupOptions() {
    const typesPromise = this.auditService.getAuditTypes();
    const categoriesPromise = this.auditService.getAuditCategories();
    const usersPromise = this.auditService.getAuditUsers();

    Promise.all([typesPromise, categoriesPromise, usersPromise]).then((values) => {
      this.auditTypes = values[0];
      this.auditCategories = values[1];
      this.auditUsers = values[2];

      this.initFilterOptions();
    });
  }

  showFilterDialog() {
    console.log('open filter dialog');
    const dialogRef = this.dialog.open(AuditListFilterDialogComponent, {
      width: '400px',
      data: {
        filter: this.selectedFilter,
        types: this.auditTypes,
        categories: this.auditCategories,
        users: this.auditUsers
      }
    });

    dialogRef.afterClosed().subscribe(async (result: SelectedFilterValuesModel[]) => {
      if (result) {
        console.log('filter dialog results', result);
        this.selectedFilterChange.emit(result);
      }
    });
  }

  onSelectedItemsChanged($event: SelectedFilterValuesModel[]) {
    this.selectedFilter = $event;
  }

  onFilterChanged(filter: any) {
    console.log('filter changed', filter);
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions =  [
      {
        filterKey: 'details',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Details'
      }
    ];

    if (this.auditTypes?.length > 0) {
      for (const type of this.auditTypes) {
        this.filterOptions.push({
          filterKey: 'type',
          multiValue: false,
          showAlways: false,
          type: 'static',
          title: 'Type',
          displayValue: type.text,
          value: type.id,
          searchText: `Type: ${type.text}`,
        });
      }
    }

    if (this.auditCategories?.length > 0) {
      for (const category of this.auditCategories) {
        this.filterOptions.push({
          filterKey: 'category',
          multiValue: false,
          showAlways: false,
          type: 'static',
          title: 'Category',
          displayValue: category.text,
          value: category.id,
          searchText: `Category: ${category.text}`,
        });
      }
    }

    if (this.auditUsers?.length > 0) {
      for (const user of this.auditUsers) {
        this.filterOptions.push({
          filterKey: 'customerUserId',
          multiValue: false,
          showAlways: false,
          type: 'static',
          title: 'User',
          displayValue: user.text,
          value: user.id,
          searchText: `User: ${user.text}`,
        });
      }
    }
  }
}
